/**
 * Config récompenses / gamification Conakry en Poche
 * (partagée conceptuellement avec functions/rewards.js — garder aligné)
 */

export const LEVEL_POINTS_STEP = 100;

export const POINTS_ACTIONS = {
  SIGNUP: 50,
  FIRST_BOOKING: 100,
  REFERRAL: 100,
  REFERRAL_SIGNUP: 50,
  REVIEW: 25,
  COMPLETE_PROFILE: 30
};

export const BADGE_THRESHOLDS = [
  { id: 'bronze', points: 100, nameFr: 'Explorateur', nameEn: 'Explorer' },
  { id: 'silver', points: 500, nameFr: 'Habitué', nameEn: 'Regular' },
  { id: 'gold', points: 1000, nameFr: 'Ambassadeur', nameEn: 'Ambassador' },
  { id: 'platinum', points: 2500, nameFr: 'Expert', nameEn: 'Expert' },
  { id: 'diamond', points: 5000, nameFr: 'Légende', nameEn: 'Legend' },
  { id: 'premium', points: null, nameFr: 'Premium', nameEn: 'Premium' }
];

export const REWARD_CATALOG = [
  {
    id: 'discount_10',
    cost: 200,
    type: 'discount',
    value: 10,
    nameFr: 'Réduction 10 %',
    nameEn: '10% off',
    descFr: '10 % sur votre prochaine course taxi (jusqu’à 5 000 GNF).',
    descEn: '10% off your next taxi ride (up to 5,000 GNF).'
  },
  {
    id: 'discount_20',
    cost: 400,
    type: 'discount',
    value: 20,
    nameFr: 'Réduction 20 %',
    nameEn: '20% off',
    descFr: '20 % sur votre prochaine course taxi (jusqu’à 10 000 GNF).',
    descEn: '20% off your next taxi ride (up to 10,000 GNF).'
  },
  {
    id: 'free_ride',
    cost: 1000,
    type: 'free_ride',
    value: 5000,
    nameFr: 'Crédit course',
    nameEn: 'Ride credit',
    descFr: 'Crédit de 5 000 GNF sur une course taxi.',
    descEn: '5,000 GNF credit on a taxi ride.'
  },
  {
    id: 'premium_badge',
    cost: 2000,
    type: 'badge',
    value: 'premium',
    nameFr: 'Badge Premium',
    nameEn: 'Premium badge',
    descFr: 'Badge exclusif Premium sur votre profil.',
    descEn: 'Exclusive Premium badge on your profile.'
  }
];

export function calculateLevel(points) {
  return Math.floor(Math.max(0, Number(points) || 0) / LEVEL_POINTS_STEP) + 1;
}

export function pointsToNextLevel(points) {
  const p = Math.max(0, Number(points) || 0);
  const step = LEVEL_POINTS_STEP;
  return step - (p % step);
}

export function levelProgressRatio(points) {
  const p = Math.max(0, Number(points) || 0);
  return (p % LEVEL_POINTS_STEP) / LEVEL_POINTS_STEP;
}

export function localizeReward(reward, language = 'fr') {
  if (!reward) return null;
  const fr = language !== 'en';
  return {
    ...reward,
    name: fr ? reward.nameFr : reward.nameEn,
    description: fr ? reward.descFr : reward.descEn
  };
}

export function localizeBadge(badgeId, language = 'fr') {
  const rule = BADGE_THRESHOLDS.find((b) => b.id === badgeId);
  if (!rule) return badgeId;
  return language === 'en' ? rule.nameEn : rule.nameFr;
}
